import { type CoreCountryCode, CoreCountryFlag } from '@flecto/types'

export function useAddressCountryFlag() {
  return (country?: CoreCountryCode): CoreCountryFlag => {
    const defaultCountry = '🌍' as CoreCountryFlag

    if (!country) {
      return defaultCountry
    }

    return CoreCountryFlag[country] ?? defaultCountry
  }
}
